import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ContabilidadeDigitalRouter } from '@ibk/contabilidade-digital';
import { AppDomain } from '@ibk/shared-types';
export default function ContabilidadeDigital() {
    return _jsx(ContabilidadeDigitalRouter, { domain: AppDomain.ESCRITORIO });
}
